module.exports = __webpack_public_path__ + "img/astroid_curve.382b1cc0.png";